module.exports = __webpack_public_path__ + "img/brand14.73186a40.png";